export default [
    '自有产品', '中金EQ', '中金财富', '广发香港', '申万香港', '国君UK', '华泰',  '中信建投', '招商国际', '海通国际', '银河国际', 'Maybank'
];
